module.exports = __webpack_public_path__ + "img/medchem5_illustration_desktop.7bacdb9b.png";